document.addEventListener('DOMContentLoaded', function () {
  const signBtn = document.querySelector('#uboDeclarationSignBtn');
  const loadingText = {
    fr: 'Veuillez patienter...',
    en: 'Please wait...',
    es: 'Por favor, espere...',
  };

  if (!signBtn) {
    return;
  }

  const locale = getCurrentLocale();

  App.uboDeclaration = App.cable.subscriptions.create(
    {
      channel: "UboDeclarations::SignatureChannel",
      ubo_declaration_id: signBtn.dataset.uboDeclarationId,
      locale,
    },
    {
      received(data) {
        App.uboDeclaration.unsubscribe();

        if (data.status === 'success') {
          if (!!data.signer_id) {
            document.querySelector('.signature-pending')?.classList?.add('d-none');
            document.querySelector('.signature-error')?.classList?.add('d-none');
            document.querySelector('.signature-success')?.classList?.remove('d-none');

            signBtn.removeAttribute('disabled');
            signBtn.addEventListener('click', () => {
              signBtn.setAttribute('disabled', true);
              signBtn.innerHTML = loadingText[locale];

              generateIframe(data.signer_id);

              setTimeout(() => {
                document.querySelector('.signature-loader-block')?.classList?.add('d-none');
                document.querySelector('.signature-block')?.classList?.remove('d-none');
              }, 1500);
            });
          } else if (data.redirect_path) {
            window.location.href = data.redirect_path;
          }
        } else if (data.status === 'failure') {
          document.querySelector('.signature-error')?.classList?.remove('d-none');
        }
      }
    }
  );

  function generateIframe(signerId) {
    const params = [
      'iframeContainerId',
      signerId,
      { redirectionMode: 'OUT' },
    ];
    const url = document.querySelector('#iframeContainerId');

    if (url?.dataset?.universignUrl) {
      params.push(url.dataset.universignUrl);
    }

    universignSigInit(...params);
  }
});
